import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faStar, faMoneyBill, faChartLine } from "@fortawesome/free-solid-svg-icons";
import { FaPaperPlane } from "react-icons/fa6";
import { useCart } from "../context/CartContext.js";
import CounsellingModal from "../pages/CounsellingModal.js";
import { getCookie } from "utils/index";
import Image from "next/image";
import LoginPromptModal from "../components/homes/heros/LoginPromptModal"; // Import LoginPromptModal

const RecentPostBlogs = ({ tag }) => {
  const router = useRouter();
  const [recentPosts, setRecentPosts] = useState([]);

  const fetchRecentPosts = async (tag) => {
    const baseURL = process.env.NEXT_PUBLIC_GHOST_API_URL;
    const apiKey = process.env.NEXT_PUBLIC_GHOST_API_KEY;
    try {
      const res = await axios.get(
        `${baseURL}/ghost/api/v3/content/posts/?key=${apiKey}&filter=tag:${tag}&limit=5`
      );
      setRecentPosts(res.data.posts);
    } catch (error) {
      console.error("Error fetching recent posts:", error);
    }
  };

  useEffect(() => {
    if (tag) {
      fetchRecentPosts(tag);
    }
  }, [tag]);

  return (
    <div className="mt-12 px-5"> {/* Changed ml-5 to px-5 for equal padding */}
      <h2 className="text-xl font-bold mb-6">Recent Posts</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {recentPosts.map((post) => (
          <div key={post.id} className="p-2">
            <div
              className="border rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 cursor-pointer h-[320px] flex flex-col overflow-hidden"
              onClick={() => router.push(`/blogs/${post.slug}`)}
            >
              {/* Image Section */}
              <div className="h-[70%] w-full relative overflow-hidden">
                <img
                  src={post.feature_image?.replace("ghost.", "") || "/default-image.jpg"}
                  alt={post.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content Section */}
              <div className="p-4 flex flex-col justify-between flex-1 overflow-hidden">
                <h3
                  className="text-lg font-semibold truncate"
                  title={post.title}
                >
                  {post.title}
                </h3>

                <div className="mt-4 text-[#ff9245] text-sm font-semibold flex items-center">
                  View Details
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-2 h-4 w-4 text-[#ff9245]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentPostBlogs;
